import { render, staticRenderFns } from "./textCard.vue?vue&type=template&id=ad892dd2&scoped=true&"
import script from "./textCard.vue?vue&type=script&lang=js&"
export * from "./textCard.vue?vue&type=script&lang=js&"
import style0 from "./textCard.vue?vue&type=style&index=0&id=ad892dd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad892dd2",
  null
  
)

export default component.exports